import { MdsIcon } from "@/design-system/components/icon";
import styled from "@emotion/styled";

export const StyledReasoningGroup = styled.div`
  margin-top: ${({ theme }) => theme.spacing.sm};
  margin-bottom: ${({ theme }) => theme.spacing.sm};
`;

export const StyledReasoningHeader = styled.div`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.chat.header};
  font-size: ${({ theme }) => theme.fontSizes.xxsmall};
  line-height: ${({ theme }) => theme.lineHeights.xsmall};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  margin-bottom: ${({ theme }) => theme.spacing.xs};
  user-select: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const StyledThoughtProcessChevronIcon = styled(MdsIcon)`
  width: ${({ theme }) => theme.fontSizes.xxsmall};
  height: ${({ theme }) => theme.fontSizes.xxsmall};
  color: ${({ theme }) => theme.colors.chat.header};
  padding-left: ${({ theme }) => theme.spacing.xs};

  svg {
    width: ${({ theme }) => theme.fontSizes.xxsmall};
    height: ${({ theme }) => theme.fontSizes.xxsmall};
    color: ${({ theme }) => theme.colors.chat.header};
  }

  img {
    width: ${({ theme }) => theme.fontSizes.xxsmall};
    height: ${({ theme }) => theme.fontSizes.xxsmall};
  }
`;
